import Vue from 'vue'
import Vuex from 'vuex'

import Network from '../vue-components/helpers/Network'
import moment from 'moment'
import router from './router'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        session: null,
        dealer: null,
        dealerInfo: null,
        contents: null,
        userData: null,
        user: null,
        loginStatus: ``,
        language: null,
        initialLoading: true,
        applicationReady: false
    },
    getters: {
        language(state) {
            if (!state.language) {
                let language = localStorage.getItem(`language`);
                if (!language) {
                    language = navigator.language.substring(0, 2) === `fr` ? `fr` : `en`;
                }
                localStorage.setItem(`language`, language);
                state.language = language;
                moment.locale(language);
            }
            return state.language;
        },
        currentUser(state) {
            if (state.user) {
                return state.user;
            } else {
                return null;
            }
        },
        isAuthenticated(state) {
            return !!state.user;
        },
        fullName(state) {
            if (state.user)
                return state.user.first_name + ` ` + state.user.last_name;
            else
                return ``;
        }
    },
    mutations: {
        startLogin(state) {
            state.loginStatus = `loading`
        },
        authSuccess(state, data) {
            state.loginStatus = `success`;
            state.user = data;
        },
        notConnected(state, user) {
            state.loginStatus = `not_connected`;
        },
        authError(state) {
            state.loginStatus = `error`
        },
        loggedOut(state) {
            state.loginStatus = `logged_out`;
            state.user = null;
        },
        cleanState(state) {
            state.loginStatus = `logged_out`;
            state.user = null;
        },
        setUserData(state, data) {
            state.contents = data.contents;
            state.user = data.user;
            state.dealerInfo = data.dealer;
        },
        setDealer(state, dealer) {
            state.dealer = dealer;
        },
        setSession(state, session) {
            state.session = session;
        },
        setLanguage(state, language) {
            state.language = language;
            moment.locale(language);
            console.log(`test`)
        },
        changeLanguage(state) {
            let language = localStorage.getItem(`language`);
            if (language === `fr`) {
                language = `en`;
            } else {
                language = `fr`;
            }

            localStorage.setItem(`language`, language);
            state.language = language;
            return language;
        }
    },
    actions: {
        getCurrentUser({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                commit(`startLogin`);
                let token = localStorage.getItem(`token`);

                if (!token) {
                    const currentURL = new URL(document.URL);
                    const currentURLParams = new URLSearchParams(currentURL.search);

                    if (currentURLParams.has(`token`)) {
                        token = currentURLParams.get(`token`);
                    }
                    window.history.pushState({}, document.title, `/`);
                }

                if (token) {
                    Network.setToken(token);

                    Network.get(`/wifi/client/user/current-user`)
                        .then(response => {
                            const user = response.data;
                            if (user) {
                                commit(`authSuccess`, user);
                                resolve(user);
                            }
                        })
                        .catch(err => {
                            commit(`authError`, err);
                            localStorage.removeItem(`token`);
                            Network.removeToken();
                            reject(err.response);
                        });
                } else {
                    commit(`notConnected`);
                    resolve(null);
                }
            });
        },
        login({ commit, dispatch }, options) {
            return new Promise((resolve, reject) => {
                commit(`cleanState`);
                commit(`startLogin`);
                Network.post(options.url, options.params)
                    .then(response => {
                        const user = response.data;
                        localStorage.setItem(`token`, user.token);
                        Network.setToken(user.token);
                        commit(`authSuccess`, user);
                        const redirect = localStorage.getItem(`redirect`);
                        if (redirect) {
                            router.push(redirect);
                            localStorage.removeItem(`redirect`);
                        } else {
                            router.push(`/`);
                        }
                        resolve(user);
                    })
                    .catch(err => {
                        console.error(err);
                        commit(`authError`, err);
                        localStorage.removeItem(`token`);
                        Network.removeToken();
                        reject(err.response);
                    });
            });
        },
        logout({commit, dispatch}) {
            return new Promise((resolve, reject) => {
                commit(`loggedOut`);
                localStorage.removeItem(`token`);
                Network.removeToken();
                resolve();
            });
        }
    }
})
